export default __webpack_public_path__ + "static/media/ee.65f4a3d8.svg";